import React from 'react';
import { Route } from 'react-router-dom';
import DataCard from '../../Data-Collection Form/DataCard.js';
import Hospital from '../../Data-Collection Form/DataCollectionFiles/HospitalForm.js';
import ScanningCenter from '../../Data-Collection Form/DataCollectionFiles/ScanningCenterForm.js';
import CelebrityHomeForm from '../../Data-Collection Form/DataCollectionFiles/CelebrityHomeForm.js';
import MallDataForm from '../../Data-Collection Form/DataCollectionFiles/MallForm.js';
import StarHotel from '../../Data-Collection Form/DataCollectionFiles/StarHotelForm.js';
import { guardRoute } from '../ProtectedRoute';

export const dataCollectionRoutes = [
  <Route
    key="data-form-card"
    path="/DataFormCard"
    element={guardRoute(<DataCard />, '/DataFormCard')}
  />,
  <Route key="hospital-form" path="/Hospital" element={guardRoute(<Hospital />, '/Hospital')} />,
  <Route
    key="scanning-center-form"
    path="/ScanningCenter"
    element={guardRoute(<ScanningCenter />, '/ScanningCenter')}
  />,
  <Route
    key="celebrity-home-form"
    path="/CelebrityHomeForm"
    element={guardRoute(<CelebrityHomeForm />, '/CelebrityHomeForm')}
  />,
  <Route
    key="mall-form"
    path="/MallDataForm"
    element={guardRoute(<MallDataForm />, '/MallDataForm')}
  />,
  <Route key="star-hotel-form" path="/StarHotel" element={guardRoute(<StarHotel />, '/StarHotel')} />,
];
